import { PieChart } from "@mui/x-charts/PieChart";
import labels from "../../utils/labels";
import KpiCard from "./KpiCard";
import { KpiPlannedTime } from "../../types/kpi";
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg";
import { useEffect, useRef } from "react";
import KPITextLine from "../UI/kpi/KPITextLine";

const PlannedTimeCard = ({ kpiList }: { kpiList: KpiPlannedTime }) => {
  const pieChart = useRef(null);

  const slices = [
    {
      title: labels.timeWithCitizens,
      percent: kpiList.percentVisitTime,
      tooltipText: labels.visitTimeShareTooltip,
      color: "var(--col-success-1)",
      borderColor: "var(--col-success-3)",
    },
    {
      title: labels.transportationTime,
      percent: kpiList.percentDriveTime,
      tooltipText: labels.drivingTimeShareTooltip,
      color: "var(--col-graph-second)",
      borderColor: "var(--col-graph-second-2)",
    },
    {
      title: labels.employeeAppointments,
      percent: kpiList.percentEmployeeAppointmentTime,
      tooltipText: labels.employeeAppointmentTimeShareTooltip,
      color: "var(--col-graph-first)",
      borderColor: "var(--col-graph-first-1)",
    },
    {
      title: labels.appointments,
      percent: kpiList.percentAppointmentTime,
      tooltipText: labels.appointmentTimeShareTooltip,
      color: "var(--col-graph-third)",
      borderColor: "var(--col-graph-third-1)",
    },
    {
      title: labels.appointmentsWithServices,
      percent: kpiList.percentAppointmentWithServicesTime,
      tooltipText: labels.appointmentWithServicesTimeShareTooltip,
      color: "var(--col-graph-third-1)",
      borderColor: "var(--col-graph-third-2)",
    },
    {
      title: labels.outlookAppointments,
      percent: kpiList.percentOutlookTime,
      tooltipText: labels.outlookAppointmentTimeShareTooltip,
      color: "var(--col-graph-first-1)",
      borderColor: "var(--col-graph-first-2)",
    },
  ];

  useEffect(() => {
    /* Add border color to each path, based on their color. */
    slices.forEach((slice) => {
      findPathsByFill(slice.color).forEach((path) => {
        path.style.stroke = slice.borderColor;
        path.style.strokeWidth = "4px";
      });
    });
  }, [pieChart.current]);

  /* Function to find and compare path based on exact color. */
  function findPathsByFill(fillColor: string) {
    // Get all path elements
    const paths = document.querySelectorAll("path");

    // Convert to array and filter by fill
    return Array.from(paths).filter((path) => {
      const computedStyle = window.getComputedStyle(path);
      const actualFill = computedStyle.fill;

      // Convert both colors to RGB format for comparison
      const colorToRGB = (color: string) => {
        // Create a temporary div to compute color
        const div = document.createElement("div");
        div.style.color = color;
        document.body.appendChild(div);
        const rgbColor = window.getComputedStyle(div).color;
        document.body.removeChild(div);
        return rgbColor;
      };

      return colorToRGB(actualFill) === colorToRGB(fillColor);
    });
  }
  return (
    <KpiCard title={labels.plannedTime} icon={<ClockIcon />} classes="w-[60%]">
      <div className="flex gap-spacing-xl">
        <div className="w-[30%]">
          <PieChart
            ref={pieChart}
            width={170}
            height={170}
            series={[
              {
                data: slices.map((slice, index) => ({
                  id: index,
                  value: slice.percent,
                  color: slice.color,
                })),
                innerRadius: 52,
                outerRadius: 70,
                paddingAngle: 6,
                cornerRadius: 100,
                cx: 70,
                cy: 70,
              },
            ]}
          />
        </div>
        <div className="flex flex-col w-full gap-spacing-xl">
          {slices.map((slice) => (
            <KPITextLine
              key={slice.title}
              compare={false}
              title={slice.title}
              value={`${slice.percent}%`}
              tooltipText={slice.tooltipText}
              color={slice.color}
              borderColor={slice.borderColor}
            />
          ))}
        </div>
      </div>
    </KpiCard>
  );
};

export default PlannedTimeCard;
